<template>
   <v-dialog v-model="isVisible" persistent max-width="1000" v-if="request">
        <v-toolbar dark color="primary">
            <v-icon>shopping_cart</v-icon>
            <v-toolbar-title class="white--text" >Request #{{ request.id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            
            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
            
        </v-toolbar>
        <v-tabs
            v-model="tab"
            dark
            color="primary">
            <v-tab href="#tab-settings">
                Order details
            </v-tab>
        </v-tabs>
        <v-card >
            <v-card-text>
              {{ request.status }}
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-settings">
                      <v-container grid-list-lg md6 >
                        <!-- <v-layout row >
                          <div>
                            <v-chip :color="request.status ? 2 : 'secondary'" text-color="white">
                              <span v-if="request.status = 2 ">Booked</span>
                              <span v-else-if="request.status = 1">Not Booked</span>
                            </v-chip>
                            <v-chip :color="request.status ? '1' : 'secondary'" text-color="white">
                              <span v-if="request.status">Offered</span>
                              <span v-else>Not Offered</span>
                            </v-chip>                            
                            <v-chip :color="request.status ? '3' : 'secondary'" text-color="white">
                              <span v-if="request.status">Rejected</span>
                              <span v-else>Not Rejected</span>
                            </v-chip>
                          </div>
                        </v-layout> -->
                       <v-layout row>
                        <v-flex xs12>
                          <h3>{{ request.event }}</h3>
                          <br>
                          <span><b>E-Mail:</b></span>
                          <span>{{ request.email }}</span>
                          <br>
                          <span><b>Amount:</b></span>
                          <span>{{ request.amount }}</span>
                          <br>
                          <span><b>Note:</b></span>
                          <span>{{ request.note }}</span>
                        </v-flex>
                       </v-layout>
                        <v-layout row>
                          <v-flex xs12>
                              <div class="text-xs-center button-row">
                                <v-tooltip bottom>
                                    <v-btn slot="activator" fab dark :color="request.status ? 'teal': 'indigo'" @click="markBooked">
                                      <v-icon dark>done_all</v-icon>
                                    </v-btn>
                                    <span>Mark as Booked</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn slot="activator" fab dark :color="request.status ? 'teal': 'indigo'" @click="markOffered">
                                        <v-icon dark>person</v-icon>
                                    </v-btn>
                                    <span>Mark as Offered</span>
                                </v-tooltip>
                                 <v-tooltip bottom>
                                    <v-btn slot="activator" fab dark :color="request.status !== '' ? 'teal': 'indigo'" @click="markRejected">
                                      <v-icon dark>clear</v-icon>
                                    </v-btn>
                                    <span>Mark as Rejected</span>
                                </v-tooltip>
                              </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
// import ArticleList from './ArticleList'
// import AddressBox from './AddressBox'

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    request: {
      type: Object,
      required: true
    }
  },
  // components: {
  //   ArticleList,
  //   AddressBox
  // },
  data() {
    return {
      tab: 'tab-settings',
      // isMarkAsShippedVisible: false,
      // isPlacedWithFOHESVisible: false,
      // isRequiredLogoVisible: false,
      // logo: null,
      // isOrderInfoVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'requestedTickets',
      // 'logos',
      // 'user'
    ]),
  },
  methods: {
    close () {
      this.$emit('close')
    },
    markBooked () {
            this.$store.dispatch('updateMarkBooked', { id: this.request._id })
    },
    markOffered () {
            this.$store.dispatch('updateMarkOffered', { id: this.request._id })
    },
    markRejected () {
            this.$store.dispatch('updateMarkRejected', { id: this.request._id })
    }
  },
  created() {

  }
}
</script>
<style>
</style>